import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './_header';
import { Footer } from './_footer';

export const RootLayout: React.FC = () => {
    return (
        <div className="bg-[#F4F0E7] flex flex-col min-h-screen">
            <Header />
            
            <main className="flex-1 pt-[70px] md:pt-[67px]">
                <Outlet />
            </main>
            
            <Footer />
        </div>
    );
};
